export const APP_BUILD_INFO = {
  "appVersion": "1.5.24",
  "buildId": "1.5.24-2026-09-02T11:09:02.143Z",
  "builtAt": "2026-09-02T11:09:02.143Z"
} as const;
